import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined'
import { centsToDollars } from 'lib/utils/number'
import pluralize from 'lib/pluralize'
import RouterLinkButton from '../router-link-button'
import { useStyles } from './styles'
import ConfirmationNumberOutlinedIcon from '@material-ui/icons/ConfirmationNumberOutlined'

const LessonPackDetails = ({
  quantity,
  priceInCents,
  id,
  isMobile,
  bookingUrl,
}) => {
  const lesson = pluralize(quantity, 'lesson')
  const classes = useStyles()

  return (
    <Box display="flex" alignItems="flex-start" mb={3}>
      <ConfirmationNumberOutlinedIcon className={classes.rowIconPrimary} />
      <Box>
        <Typography>
          <strong>
            {quantity} {lesson} &nbsp;
          </strong>
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {`$${centsToDollars(priceInCents)} total 
          ($${centsToDollars(priceInCents / quantity)} per lesson)`}
        </Typography>
      </Box>
      <RouterLinkButton
        variant="outlined"
        to={`${bookingUrl}&isLessonPacks=true&lessonPackId=${id}`}
        startIcon={<ShoppingCartOutlinedIcon />}
        className={classes.alignRight}
      >
        Buy {isMobile ? '' : `${quantity}-pack`}
      </RouterLinkButton>
    </Box>
  )
}

export default LessonPackDetails
